import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@marekl/adminer";
import { RequireAuth } from "./auth/RequireAuth";
import { RequireGuest } from "./auth/RequireGuest";
import { AppLayout } from "./shell/AppLayout";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { ProfilePage } from "./pages/ProfilePage";
import { AuditLogPage } from "./pages/AuditLogPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { ItemsPage } from "./pages/ItemsPage";
import { NotesPage } from "./pages/NotesPage";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/login"
          element={
            <RequireGuest>
              <LoginPage />
            </RequireGuest>
          }
        />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/items" element={<ItemsPage />} />
          <Route path="/notes" element={<NotesPage />} />
          <Route
            path="/users"
            element={
              <RequireAuth roles={["superadmin"]}>
                <UsersPage />
              </RequireAuth>
            }
          />
          <Route path="/profile" element={<ProfilePage />} />
          <Route
            path="/audit-log"
            element={
              <RequireAuth roles={["manager", "superadmin"]}>
                <AuditLogPage />
              </RequireAuth>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}
